// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.home-bg {
  background: var(--randy-beige);
  width: 100%;
  height: 100vh;
  display: flex;
  flex-direction: column;
  position: relative;
}
.home-bg ion-content {
  --background: transparent;
  --padding-bottom: 80px;
}

.content-row {
  min-height: 100%;
  padding: 40px 0;
}
.content-row .content-col {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
}

.brand-logo {
  height: 140px;
  width: auto;
  max-width: 320px;
  margin-bottom: 30px;
  object-fit: contain;
}
@media (width < 390px) {
  .brand-logo {
    height: 110px;
    margin-bottom: 20px;
  }
}
@media (min-width: 991px) {
  .brand-logo {
    height: 160px;
    margin-bottom: 40px;
  }
}

.card {
  background: var(--color-white);
  padding: 0;
  margin: 0 auto 30px;
  overflow: hidden;
  min-width: 300px;
  max-width: 375px;
  width: 90%;
  text-align: center;
  border: 1px solid #939393;
  position: relative;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}
.card .pizza-section {
  padding: 25px 20px 20px;
  border-bottom: 0.5px solid var(--randy-border);
}
.card .pizza-img {
  width: 100%;
  max-width: 220px;
  margin: 0 auto;
  height: auto;
  display: block;
}
.card .button-wrap {
  padding: 18px 20px;
  display: flex;
  flex-direction: column;
  gap: 10px;
  border-bottom: 0.5px solid var(--randy-border);
}
.card .button-wrap .btn {
  width: 100%;
  height: 50px;
  border: none;
  border-radius: 4px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  transition: all 0.3s ease;
}
.card .button-wrap .btn span {
  font-family: AppFont, sans-serif;
  font-size: 16px;
  font-weight: 500;
  line-height: 135%;
}
.card .button-wrap .btn.btn-primary {
  background: var(--randy-red);
  color: white;
}
.card .button-wrap .btn.btn-primary:hover {
  background: var(--randy-red-dark);
}
.card .button-wrap .btn.btn-primary span {
  color: white;
}
.card .button-wrap .btn.btn-secondary {
  background: var(--randy-gray);
  color: white;
}
.card .button-wrap .btn.btn-secondary:hover {
  background: var(--randy-gray-dark);
}
.card .button-wrap .btn.btn-secondary span {
  color: white;
}
.card .info-section {
  padding: 18px 20px;
  border-bottom: 0.5px solid var(--randy-border);
}
.card .info-text {
  color: var(--randy-gray);
  font-family: AppFont;
  font-weight: 500;
  font-size: 14px;
  line-height: 150%;
  text-align: center;
  margin: 0;
}
.card .payment-section {
  padding: 18px 20px;
  border-bottom: 0.5px solid var(--randy-border);
}
.card .payment-title {
  font-family: AppFont;
  font-weight: 400;
  font-size: 12px;
  line-height: 150%;
  text-align: center;
  color: #666666;
  margin: 0 0 12px 0;
}
.card .payment-icons {
  width: 100%;
  height: 20px;
  max-width: 200px;
  margin: 0 auto;
  display: block;
}
.card .allergen-section {
  padding: 18px 20px;
}
.card .allergen-link {
  cursor: pointer;
  color: var(--randy-red);
  font-family: AppFont;
  font-weight: 400;
  font-size: 14px;
  line-height: 135%;
  text-align: center;
  text-decoration: underline;
  text-decoration-style: solid;
  display: block;
}
.card .allergen-link:hover {
  color: var(--randy-red-dark);
}

ion-footer {
  --background: var(--randy-beige);
  background: var(--randy-beige);
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 10;
  padding: 0;
  box-shadow: none;
  border: none;
}
ion-footer::before {
  display: none;
}

.lang-block {
  padding-bottom: 20px;
  background: var(--randy-beige);
}
@media (width < 390px) {
  .lang-block {
    padding-bottom: 15px;
  }
}

.footer-lang {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 10px;
  max-width: max-content;
  margin: 0 auto;
  padding: 0 20px;
}
.footer-lang .lang-option {
  text-align: center;
  background: #fff;
  border: 1px solid var(--randy-gray);
  border-radius: 4px;
  overflow: hidden;
  padding: 12px 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: -moz-fit-content;
  width: fit-content;
  cursor: pointer;
  transition: all 0.3s ease;
}
.footer-lang .lang-option span {
  margin-left: 8px;
  text-transform: uppercase;
  font-family: AppFontSemiBold;
  font-size: 14px;
  color: var(--randy-gray);
  font-weight: 600;
}
.footer-lang .lang-option ion-icon {
  height: 16px;
  width: 24px;
}
.footer-lang .lang-option.selected {
  background: var(--randy-gray);
  border-color: var(--randy-gray);
}
.footer-lang .lang-option.selected span {
  color: white;
}
.footer-lang .lang-option:hover:not(.selected) {
  background: var(--randy-beige-dark);
}

.select-preorder-container {
  padding: 20px;
  width: 100%;
}
.select-preorder-container .selection-title {
  padding: 0 0 20px 0;
  font-family: AppFont;
  font-weight: 500;
  font-size: 16px;
  line-height: 150%;
  color: var(--randy-gray);
  width: 100%;
  margin: 0;
}
.select-preorder-container .preorder-option.inside {
  padding-right: 5px;
}
.select-preorder-container .preorder-option.take_away {
  padding-left: 5px;
}
.select-preorder-container .preorder-option .select-preorder-img {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 40px;
  border: 0.5px solid var(--randy-border);
  border-bottom: none;
  background: white;
}
.select-preorder-container .preorder-option ion-button {
  width: 100%;
  --background: var(--randy-red);
  --color: white;
  font-family: AppFont;
  font-weight: 500;
  font-size: 14px;
  line-height: 135%;
  text-transform: capitalize;
  height: 45px;
}

ion-spinner {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  --color: var(--randy-red);
}`, "",{"version":3,"sources":["webpack://./src/app/pages/home/home.page.scss","webpack://./src/theme/mixins.scss"],"names":[],"mappings":"AAEA;EACC,8BAAA;EACA,WAAA;EACA,aAAA;EACA,aAAA;EACA,sBAAA;EACA,kBAAA;AADD;AAGC;EACC,yBAAA;EACA,sBAAA;AADF;;AAKA;EACC,gBAAA;EACA,eAAA;AAFD;AAIC;EACC,aAAA;EACA,sBAAA;EACA,2BAAA;EACA,mBAAA;AAFF;;AAMA;EACC,aAAA;EACA,WAAA;EACA,gBAAA;EACA,mBAAA;EACA,mBAAA;AAHD;AAKC;EAPD;IAQE,aAAA;IACA,mBAAA;EAFA;AACF;ACnCE;ED2BF;IAaE,aAAA;IACA,mBAAA;EADA;AACF;;AAIA;EACC,8BAAA;EACA,UAAA;EACA,mBAAA;EACA,gBAAA;EACA,gBAAA;EACA,gBAAA;EACA,UAAA;EACA,kBAAA;EACA,yBAAA;EACA,kBAAA;EACA,yCAAA;AADD;AAGC;EACC,uBAAA;EACA,8CAAA;AADF;AAIC;EACC,WAAA;EACA,gBAAA;EACA,cAAA;EACA,YAAA;EACA,cAAA;AAFF;AAKC;EACC,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;EACA,8CAAA;AAHF;AAKE;EACC,WAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;EACA,yBAAA;AAHH;AAKG;EACC,gCAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;AAHJ;AAMG;EACC,4BAAA;EACA,YAAA;AAJJ;AAMI;EACC,iCAAA;AAJL;AAOI;EACC,YAAA;AALL;AASG;EACC,6BAAA;EACA,YAAA;AAPJ;AASI;EACC,kCAAA;AAPL;AAUI;EACC,YAAA;AARL;AAcC;EACC,kBAAA;EACA,8CAAA;AAZF;AAeC;EACC,wBAAA;EACA,oBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,SAAA;AAbF;AAgBC;EACC,kBAAA;EACA,8CAAA;AAdF;AAiBC;EACC,oBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,cAAA;EACA,kBAAA;AAfF;AAkBC;EACC,WAAA;EACA,YAAA;EACA,gBAAA;EACA,cAAA;EACA,cAAA;AAhBF;AAmBC;EACC,kBAAA;AAjBF;AAoBC;EACC,eAAA;EACA,uBAAA;EACA,oBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,0BAAA;EACA,4BAAA;EACA,cAAA;AAlBF;AAoBE;EACC,4BAAA;AAlBH;;AAuBA;EACC,gCAAA;EACA,8BAAA;EACA,eAAA;EACA,SAAA;EACA,OAAA;EACA,QAAA;EACA,WAAA;EACA,UAAA;EACA,gBAAA;EACA,YAAA;AApBD;AAsBC;EACC,aAAA;AApBF;;AAwBA;EACC,oBAAA;EACA,8BAAA;AArBD;AAuBC;EAJD;IAKE,oBAAA;EApBA;AACF;;AAuBA;EACC,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,SAAA;EACA,sBAAA;EACA,cAAA;EACA,eAAA;AApBD;AAsBC;EACC,kBAAA;EACA,gBAAA;EACA,mCAAA;EACA,kBAAA;EACA,gBAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,uBAAA;EAAA,kBAAA;EACA,eAAA;EACA,yBAAA;AApBF;AAsBE;EACC,gBAAA;EACA,yBAAA;EACA,4BAAA;EACA,eAAA;EACA,wBAAA;EACA,gBAAA;AApBH;AAuBE;EACC,YAAA;EACA,WAAA;AArBH;AAwBE;EACC,6BAAA;EACA,+BAAA;AAtBH;AAwBG;EACC,YAAA;AAtBJ;AA0BE;EACC,mCAAA;AAxBH;;AA4BA;EACC,aAAA;EACA,WAAA;AAzBD;AA2BC;EACC,mBAAA;EACA,oBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,wBAAA;EACA,WAAA;EACA,SAAA;AAzBF;AA6BE;EACC,kBAAA;AA3BH;AA8BE;EACC,iBAAA;AA5BH;AA+BE;EACC,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,aAAA;EACA,uCAAA;EACA,mBAAA;EACA,iBAAA;AA7BH;AAgCE;EACC,WAAA;EACA,8BAAA;EACA,cAAA;EACA,oBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,0BAAA;EACA,YAAA;AA9BH;;AAmCA;EACC,kBAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;EACA,yBAAA;AAhCD","sourcesContent":["@use \"../../../theme/mixins\" as *;\n\n.home-bg {\n\tbackground: var(--randy-beige);\n\twidth: 100%;\n\theight: 100vh;\n\tdisplay: flex;\n\tflex-direction: column;\n\tposition: relative;\n\n\tion-content {\n\t\t--background: transparent;\n\t\t--padding-bottom: 80px; // Space for language footer\n\t}\n}\n\n.content-row {\n\tmin-height: 100%;\n\tpadding: 40px 0;\n\n\t.content-col {\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t\tjustify-content: flex-start;\n\t\talign-items: center;\n\t}\n}\n\n.brand-logo {\n\theight: 140px;\n\twidth: auto;\n\tmax-width: 320px;\n\tmargin-bottom: 30px;\n\tobject-fit: contain;\n\t\n\t@media (width < 390px) {\n\t\theight: 110px;\n\t\tmargin-bottom: 20px;\n\t}\n\t\n\t@include desktop {\n\t\theight: 160px;\n\t\tmargin-bottom: 40px;\n\t}\n}\n\n.card {\n\tbackground: var(--color-white);\n\tpadding: 0;\n\tmargin: 0 auto 30px;\n\toverflow: hidden;\n\tmin-width: 300px;\n\tmax-width: 375px;\n\twidth: 90%;\n\ttext-align: center;\n\tborder: 1px solid #939393;\n\tposition: relative;\n\tbox-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);\n\n\t.pizza-section {\n\t\tpadding: 25px 20px 20px;\n\t\tborder-bottom: 0.5px solid var(--randy-border);\n\t}\n\n\t.pizza-img {\n\t\twidth: 100%;\n\t\tmax-width: 220px;\n\t\tmargin: 0 auto;\n\t\theight: auto;\n\t\tdisplay: block;\n\t}\n\n\t.button-wrap {\n\t\tpadding: 18px 20px;\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t\tgap: 10px;\n\t\tborder-bottom: 0.5px solid var(--randy-border);\n\n\t\t.btn {\n\t\t\twidth: 100%;\n\t\t\theight: 50px;\n\t\t\tborder: none;\n\t\t\tborder-radius: 4px;\n\t\t\tdisplay: flex;\n\t\t\tjustify-content: center;\n\t\t\talign-items: center;\n\t\t\tcursor: pointer;\n\t\t\ttransition: all 0.3s ease;\n\n\t\t\tspan {\n\t\t\t\tfont-family: AppFont, sans-serif;\n\t\t\t\tfont-size: 16px;\n\t\t\t\tfont-weight: 500;\n\t\t\t\tline-height: 135%;\n\t\t\t}\n\n\t\t\t&.btn-primary {\n\t\t\t\tbackground: var(--randy-red);\n\t\t\t\tcolor: white;\n\n\t\t\t\t&:hover {\n\t\t\t\t\tbackground: var(--randy-red-dark);\n\t\t\t\t}\n\n\t\t\t\tspan {\n\t\t\t\t\tcolor: white;\n\t\t\t\t}\n\t\t\t}\n\n\t\t\t&.btn-secondary {\n\t\t\t\tbackground: var(--randy-gray);\n\t\t\t\tcolor: white;\n\n\t\t\t\t&:hover {\n\t\t\t\t\tbackground: var(--randy-gray-dark);\n\t\t\t\t}\n\n\t\t\t\tspan {\n\t\t\t\t\tcolor: white;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n\n\t.info-section {\n\t\tpadding: 18px 20px;\n\t\tborder-bottom: 0.5px solid var(--randy-border);\n\t}\n\n\t.info-text {\n\t\tcolor: var(--randy-gray);\n\t\tfont-family: AppFont;\n\t\tfont-weight: 500;\n\t\tfont-size: 14px;\n\t\tline-height: 150%;\n\t\ttext-align: center;\n\t\tmargin: 0;\n\t}\n\n\t.payment-section {\n\t\tpadding: 18px 20px;\n\t\tborder-bottom: 0.5px solid var(--randy-border);\n\t}\n\n\t.payment-title {\n\t\tfont-family: AppFont;\n\t\tfont-weight: 400;\n\t\tfont-size: 12px;\n\t\tline-height: 150%;\n\t\ttext-align: center;\n\t\tcolor: #666666;\n\t\tmargin: 0 0 12px 0;\n\t}\n\n\t.payment-icons {\n\t\twidth: 100%;\n\t\theight: 20px;\n\t\tmax-width: 200px;\n\t\tmargin: 0 auto;\n\t\tdisplay: block;\n\t}\n\n\t.allergen-section {\n\t\tpadding: 18px 20px;\n\t}\n\n\t.allergen-link {\n\t\tcursor: pointer;\n\t\tcolor: var(--randy-red);\n\t\tfont-family: AppFont;\n\t\tfont-weight: 400;\n\t\tfont-size: 14px;\n\t\tline-height: 135%;\n\t\ttext-align: center;\n\t\ttext-decoration: underline;\n\t\ttext-decoration-style: solid;\n\t\tdisplay: block;\n\n\t\t&:hover {\n\t\t\tcolor: var(--randy-red-dark);\n\t\t}\n\t}\n}\n\nion-footer {\n\t--background: var(--randy-beige);\n\tbackground: var(--randy-beige);\n\tposition: fixed;\n\tbottom: 0;\n\tleft: 0;\n\tright: 0;\n\tz-index: 10;\n\tpadding: 0;\n\tbox-shadow: none;\n\tborder: none;\n\n\t&::before {\n\t\tdisplay: none;\n\t}\n}\n\n.lang-block {\n\tpadding-bottom: 20px;\n\tbackground: var(--randy-beige);\n\t\n\t@media (width < 390px) {\n\t\tpadding-bottom: 15px;\n\t}\n}\n\n.footer-lang {\n\tdisplay: flex;\n\tjustify-content: center;\n\talign-items: center;\n\tgap: 10px;\n\tmax-width: max-content;\n\tmargin: 0 auto;\n\tpadding: 0 20px;\n\t\n\t.lang-option {\n\t\ttext-align: center;\n\t\tbackground: #fff;\n\t\tborder: 1px solid var(--randy-gray);\n\t\tborder-radius: 4px;\n\t\toverflow: hidden;\n\t\tpadding: 12px 20px;\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t\tjustify-content: center;\n\t\twidth: fit-content;\n\t\tcursor: pointer;\n\t\ttransition: all 0.3s ease;\n\n\t\tspan {\n\t\t\tmargin-left: 8px;\n\t\t\ttext-transform: uppercase;\n\t\t\tfont-family: AppFontSemiBold;\n\t\t\tfont-size: 14px;\n\t\t\tcolor: var(--randy-gray);\n\t\t\tfont-weight: 600;\n\t\t}\n\n\t\tion-icon {\n\t\t\theight: 16px;\n\t\t\twidth: 24px;\n\t\t}\n\n\t\t&.selected {\n\t\t\tbackground: var(--randy-gray);\n\t\t\tborder-color: var(--randy-gray);\n\n\t\t\tspan {\n\t\t\t\tcolor: white;\n\t\t\t}\n\t\t}\n\n\t\t&:hover:not(.selected) {\n\t\t\tbackground: var(--randy-beige-dark);\n\t\t}\n\t}\n}\n.select-preorder-container {\n\tpadding: 20px;\n\twidth: 100%;\n\n\t.selection-title {\n\t\tpadding: 0 0 20px 0;\n\t\tfont-family: AppFont;\n\t\tfont-weight: 500;\n\t\tfont-size: 16px;\n\t\tline-height: 150%;\n\t\tcolor: var(--randy-gray);\n\t\twidth: 100%;\n\t\tmargin: 0;\n\t}\n\n\t.preorder-option {\n\t\t&.inside {\n\t\t\tpadding-right: 5px;\n\t\t}\n\t\t\n\t\t&.take_away {\n\t\t\tpadding-left: 5px;\n\t\t}\n\n\t\t.select-preorder-img {\n\t\t\tdisplay: flex;\n\t\t\tjustify-content: center;\n\t\t\talign-items: center;\n\t\t\tpadding: 40px;\n\t\t\tborder: 0.5px solid var(--randy-border);\n\t\t\tborder-bottom: none;\n\t\t\tbackground: white;\n\t\t}\n\n\t\tion-button {\n\t\t\twidth: 100%;\n\t\t\t--background: var(--randy-red);\n\t\t\t--color: white;\n\t\t\tfont-family: AppFont;\n\t\t\tfont-weight: 500;\n\t\t\tfont-size: 14px;\n\t\t\tline-height: 135%;\n\t\t\ttext-transform: capitalize;\n\t\t\theight: 45px;\n\t\t}\n\t}\n}\n\nion-spinner {\n\tposition: absolute;\n\ttop: 50%;\n\tleft: 50%;\n\ttransform: translate(-50%, -50%);\n\t--color: var(--randy-red);\n}\n","@mixin desktop {\n  @media (min-width: 991px) {\n    @content;\n  }\n}\n\n@mixin mobile {\n  @media (max-width: 992px) {\n    @content\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
